/**
 * English translations for admin panel.
 */

const admin = {
  fal: {
    status: 'FAL Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    approve: 'Approve FAL',
    reject: 'Reject FAL',
    revoke: 'Revoke FAL',
    rejectTitle: 'Reject FAL License',
    rejectReason: 'Rejection Reason',
    rejectReasonPlaceholder: 'Explain why the FAL license is being rejected...',
    confirmReject: 'Confirm Rejection',
    licenseNumber: 'FAL License #',
    noLicense: 'No license submitted',
    approved_toast: 'FAL license approved successfully',
    rejected_toast: 'FAL license rejected',
    revoked_toast: 'FAL license revoked (set to pending)',
  },

  // Two-factor setup for admin accounts (pages/admin/setup-2fa/page.tsx).
  twoFa: {
    title: 'Set up two-factor authentication',
    subtitle: 'Required for admin accounts',
    loading: 'Loading…',
    steps: {
      label: 'Two-factor setup steps',
      scan: 'Scan the code',
      verify: 'Confirm the code',
      backup: 'Backup codes',
    },
    scanIntro: 'Scan this QR code with your authenticator app (Google Authenticator, Authy, 1Password):',
    qrAlt: 'QR code for two-factor setup',
    manualHint: "Can't scan? Enter this code manually:",
    added: "I've added it - verify",
    verifyIntro: 'Enter the 6-digit code shown in your authenticator app:',
    codeLabel: 'Verification code',
    verify: 'Verify',
    verifying: 'Verifying…',
    back: 'Back',
    confirmFailed: 'Confirmation failed. Please try again.',
    backupTitle: 'Save these backup codes now.',
    backupBody: 'They appear only ONCE. Each one is a single-use replacement for your authenticator app.',
    acknowledge: "I've saved these codes in a safe place",
    finish: 'Finish',
  },
};

export default admin;
